import { useState, useEffect } from "react";

// Sample country code list (you can expand this)
const countryCodes = [
  { name: "Philippines", code: "+63", iso2: "PH", flag: "🇵🇭" },
  { name: "United States", code: "+1", iso2: "US", flag: "🇺🇸" },
  { name: "United Kingdom", code: "+44", iso2: "GB", flag: "🇬🇧" },
  { name: "India", code: "+91", iso2: "IN", flag: "🇮🇳" },
  { name: "Japan", code: "+81", iso2: "JP", flag: "🇯🇵" },
  { name: "China", code: "+86", iso2: "CN", flag: "🇨🇳" },
  { name: "Germany", code: "+49", iso2: "DE", flag: "🇩🇪" },
  { name: "France", code: "+33", iso2: "FR", flag: "🇫🇷" },
  { name: "Canada", code: "+1", iso2: "CA", flag: "🇨🇦" },
  { name: "Australia", code: "+61", iso2: "AU", flag: "🇦🇺" },
];

export default function InputPhoneWithCountry({
  defaultValue = "",
  onChange,
  required,
  ...props
}) {
  const [prefix, setPrefix] = useState("+63");
  const [number, setNumber] = useState("");

  // Match prefix from defaultValue
  useEffect(() => {
    const match = countryCodes.find((c) => defaultValue?.startsWith(c.code));
    if (match) {
      setPrefix(match.code);
      setNumber(defaultValue.slice(match.code.length));
    } else {
      setNumber(defaultValue);
    }
  }, [defaultValue]);

  const handlePrefixChange = (e) => {
    const newPrefix = e.target.value;
    setPrefix(newPrefix);
    onChange?.(`${newPrefix}${number}`);
  };

  const handleNumberChange = (e) => {
    const raw = e.target.value.replace(/\D/g, "").slice(0, 15); // max 15 digits
    setNumber(raw);
    onChange?.(`${prefix}${raw}`);
  };

  return (
    <div className="input-group">
      <select
        className="form-select"
        value={prefix}
        onChange={handlePrefixChange}
      >
        {countryCodes.map((c) => (
          <option key={c.code + c.iso2} value={c.code}>
            {c.flag} {c.iso2} ({c.code})
          </option>
        ))}
      </select>
      <input
        type="text"
        className="form-control"
        value={number}
        onChange={handleNumberChange}
        required={required}
        placeholder="Enter phone number"
        {...props}
      />
    </div>
  );
}
